<a [matTooltip]="tooltip" class="tile-link" [href]="externalLink">
  <div [ngClass]="isUseCase ? 'tile useCase' : isSuperUserOnly ? 'tile superUserOnly' : 'tile subApp'">
    <div class="tile-icon">
      <mat-icon [inline]="true">{{ icon }}</mat-icon>
    </div>
    <span class="tile-label">{{ label }}</span>
  </div>
</a>
